export const ejmWorkflowGuide =
  'How the external job market works: pick a datapool with switch_ejm_datapool, then drive the on-screen ' +
  'job list with search_and_filter_ejm_jobs. Read matching jobs from context.current_page.visibleJobs ' +
  '(and the rest of context.current_page for datapools, filters, and available properties). ' +
  'get_ejm_job_details returns the full record for a job id visible in the current datapool. Prefer specific filters over free-text search.';
